// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "td[data-v-3bfbbea4]{vertical-align:middle!important;padding:.25rem!important}", ""]);
// Exports
module.exports = exports;
